module.exports = __webpack_public_path__ + "img/ic_info.2acaf68d.svg";